const findConceptProperties = (concept, propertyCodes) => {
    let properties = {};

    for (let propertyIndex in concept.property) {
        let property = concept.property[propertyIndex];
        let valueString = property.valueString;

        if (valueString) {
            if (propertyCodes.includes(property.code)) {
                properties[property.code] = valueString
            } else {
                alert("A property exists in this term that's not defined at the CodeSystem level. This data will be deleted if saved.");
            }
        }
    }
    for (let codeIndex in propertyCodes) {
        let code = propertyCodes[codeIndex];
        if (properties[code] === undefined) {
            properties[code] = "";
        }
    }

    return properties;
};

export default findConceptProperties;